import React, { useContext, useEffect, useState } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';
import { dbPost } from '../../apis/commonApi';
import { nlPost } from '../../apis/notLoginApi';
import { useNavigate } from 'react-router-dom';

const AdminUserList = () => {
  useEffect(() => {
    document.title = '사용자관리 목록';
  }, []);
  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const [userList, setUserList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();
  const validateService = new ValidateService(modalService);

  const paginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return userList.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const getUserList = async () => {
    const url = '/adminUser/getUserList.do';
    dbPost(url)
      .then(response => {
        const userList = Array.isArray(response) ? response : [];
        setUserList(userList);
      })
      .catch(error => {});
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  };

  useEffect(() => {
    const initialize = async () => {
      await getUserList();
    };
    initialize();
  }, []);

  const activation = async (paramOne, paramTwo) => {
    const url = '/adminUser/userActivate.do';
    const postParam = {
      userSn: paramOne,
      useYn: paramTwo === 'Y' ? 'Y' : 'N',
      memberType: 'user',
    };
    try {
      const response = await dbPost(url, postParam);
      await getUserList();
      if (paramTwo === 'Y') {
        await modalService.successAlert('사용자를 비활성화 하였습니다.');
      } else if (paramTwo === 'N') {
        await modalService.successAlert('사용자를 활성화 하였습니다.');
      }
    } catch (error) {}
  };
  const userInfo = userId => {
    navigate('/member/userInfo/adminUserInfo', {
      state: { userId: userId, userType: 'U' },
    });
  };

  const newMemberUser = () => {
    navigate('/member/joinEmlChk');
  };

  const [checkedItems, setCheckedItems] = useState([]);

  const handleAllCheck = e => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allItems = userList.map(item => ({
        userSn: item.wrkrSn,
        useYn: item.useYn,
      }));
      setCheckedItems(allItems);
    } else {
      setCheckedItems([]);
    }
  };

  const renewPassword = (valOne, valTwo, valThr, valFour) => {
    const url = '/member/recoverPassword.do';
    const postParam = {
      id: valOne,
      name: valTwo,
      email: valThr,
      memberType: 'user',
    };
    if (postParam.email === '' || postParam.email === null) {
      modalService.errorAlert('등록된 이메일이 없습니다.', () => {});
      return;
    }
    nlPost(url, postParam)
      .then(response => {
        if (response.code == '2') {
          modalService.errorAlert('등록된 회원이 없습니다.');
        } else {
          modalService.successAlert(
            '임시 비밀번호를 전송하였습니다.',
            () => {}
          );
        }
      })
      .catch(error => {});
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자관리</h2>
      </div>
      <div className="tbl-wrap">
        <h3 className="block-tit">사용자 목록</h3>
        <div className="tbl-scroll-box">
          <table className="tbl col data">
            <thead>
              <tr>
                <th scope="col">사용자 아이디</th>
                <th scope="col">이름</th>
                <th scope="col">전화번호</th>
                <th scope="col">휴대전화</th>
                <th scope="col">이메일 주소</th>
                <th scope="col">소속기업명</th>
                <th scope="col">
                  소속기업
                  <br />
                  사업자등록번호
                </th>
                <th scope="col">가입일자</th>
                <th scope="col">계정 활성화</th>
                <th scope="col">패스워드 초기화</th>
              </tr>
            </thead>
            <tbody>
              {/*시작*/}
              {paginatedData().map((userList, index) => (
                <tr key={index}>
                  <td>
                    <a
                      className="btn btn-txt underline"
                      onClick={e => {
                        e.preventDefault();
                        userInfo(userList.userId);
                      }}
                    >
                      {userList.userId || '-'}
                    </a>
                  </td>
                  <td>{userList.userNm || '-'}</td>
                  <td>{userList.userTelno || '-'}</td>
                  <td>{userList.userMblTelno || '-'}</td>
                  <td>{userList.userEml || '-'}</td>
                  <td>{userList.entNm || '-'}</td>
                  <td>{userList.brno || '-'}</td>
                  <td>{userList.regDt || '-'}</td>
                  <td>
                    {userList.useYn == 'Y' ? (
                      <a
                        className="btn sm secondary"
                        onClick={() => {
                          activation(userList.userSn, userList.useYn);
                        }}
                      >
                        비활성화
                      </a>
                    ) : (
                      <a
                        className="btn sm secondary"
                        onClick={() => {
                          activation(userList.userSn, userList.useYn);
                        }}
                      >
                        활성화
                      </a>
                    )}
                  </td>
                  <td>
                    <a
                      className="btn sm tertiary"
                      onClick={() => {
                        renewPassword(
                          userList.userId,
                          userList.userNm,
                          userList.userEml,
                          userList.userSn
                        );
                      }}
                    >
                      초기화
                    </a>
                  </td>
                </tr>
              ))}
              {/*껕*/}
            </tbody>
          </table>
        </div>
      </div>
      <GbitTablePaging
        totalItems={userList.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
      <div className="page-btn-wrap">
        <button
          type="button"
          className="btn xlg primary"
          onClick={newMemberUser}
        >
          신규등록
        </button>
      </div>
    </>
  );
};

export default AdminUserList;
